var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _path24, _g, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHaveto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 631,
    height: 101,
    viewBox: "0 0 631 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9429 3.59375C22.1623 3.59375 23.1508 4.5823 23.1509 5.80176V95.9258C23.1507 97.1451 22.1622 98.1338 20.9429 98.1338H4.63525C3.41591 98.1338 2.42742 97.1451 2.42725 95.9258V5.80176C2.42728 4.58232 3.41582 3.59378 4.63525 3.59375H20.9429ZM69.4458 40.9678C70.6653 40.9678 71.6548 41.9563 71.6548 43.1758V95.8154C71.6547 97.0348 70.6652 98.0234 69.4458 98.0234H53.1382C51.9189 98.0233 50.9303 97.0348 50.9302 95.8154V63.9639C50.9302 62.7444 49.9416 61.7559 48.7221 61.7559H25.3599C24.1404 61.7559 23.1519 60.7673 23.1519 59.5478V43.1758C23.1519 41.9564 24.1404 40.9678 25.3599 40.9678H69.4458Z",
    fill: "#131314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08643 1.44727C4.51321 1.44747 5.67218 2.60805 5.67236 4.04297C5.67236 5.47805 4.51332 6.63945 3.08643 6.63965C1.65936 6.63965 0.499512 5.47817 0.499512 4.04297C0.499693 2.60792 1.65947 1.44727 3.08643 1.44727Z",
    fill: "white",
    stroke: "#131314"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08643 94.9902C4.51321 94.9904 5.67218 96.151 5.67236 97.5859C5.67236 99.021 4.51332 100.182 3.08643 100.183C1.65936 100.183 0.499512 99.0211 0.499512 97.5859C0.499693 96.1509 1.65947 94.9902 3.08643 94.9902Z",
    fill: "white",
    stroke: "#131314"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08643 79.0684C4.51321 79.0686 5.67218 80.2291 5.67236 81.6641C5.67236 83.0991 4.51332 84.2605 3.08643 84.2607C1.65936 84.2607 0.499512 83.0993 0.499512 81.6641C0.499693 80.229 1.65947 79.0684 3.08643 79.0684Z",
    fill: "white",
    stroke: "#131314"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08643 63.0801C4.51321 63.0803 5.67218 64.2409 5.67236 65.6758C5.67236 67.1109 4.51332 68.2723 3.08643 68.2725C1.65936 68.2725 0.499512 67.111 0.499512 65.6758C0.499693 64.2407 1.65947 63.0801 3.08643 63.0801Z",
    fill: "white",
    stroke: "#131314"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08643 50.5352C4.51321 50.5354 5.67218 51.6959 5.67236 53.1309C5.67236 54.5659 4.51332 55.7273 3.08643 55.7275C1.65936 55.7275 0.499512 54.5661 0.499512 53.1309C0.499693 51.6958 1.65947 50.5352 3.08643 50.5352Z",
    fill: "white",
    stroke: "#131314"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08643 30.0293C4.51321 30.0295 5.67218 31.1901 5.67236 32.625C5.67236 34.0601 4.51332 35.2215 3.08643 35.2217C1.65936 35.2217 0.499512 34.0602 0.499512 32.625C0.499693 31.19 1.65947 30.0293 3.08643 30.0293Z",
    fill: "white",
    stroke: "#131314"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5891 94.9902C53.0159 94.9904 54.1749 96.151 54.175 97.5859C54.175 99.021 53.016 100.182 51.5891 100.183C50.162 100.183 49.0022 99.0211 49.0022 97.5859C49.0024 96.1509 50.1622 94.9902 51.5891 94.9902Z",
    fill: "white",
    stroke: "#131314"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5891 82.1387C53.0159 82.1389 54.1749 83.2995 54.175 84.7344C54.175 86.1695 53.016 87.3309 51.5891 87.3311C50.162 87.3311 49.0022 86.1696 49.0022 84.7344C49.0024 83.2993 50.1622 82.1387 51.5891 82.1387Z",
    fill: "white",
    stroke: "#131314"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4879 1.44727C23.9147 1.44747 25.0737 2.60805 25.0739 4.04297C25.0739 5.47805 23.9148 6.63945 22.4879 6.63965C21.0609 6.63965 19.901 5.47817 19.901 4.04297C19.9012 2.60792 21.061 1.44727 22.4879 1.44727Z",
    fill: "white",
    stroke: "#131314"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4879 15.8359C23.9147 15.8361 25.0737 16.9967 25.0739 18.4316C25.0739 19.8667 23.9148 21.0281 22.4879 21.0283C21.0609 21.0283 19.901 19.8668 19.901 18.4316C19.9012 16.9966 21.061 15.8359 22.4879 15.8359Z",
    fill: "white",
    stroke: "#131314"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4879 94.9902C23.9147 94.9904 25.0737 96.151 25.0739 97.5859C25.0739 99.021 23.9148 100.182 22.4879 100.183C21.0609 100.183 19.901 99.0211 19.901 97.5859C19.9012 96.1509 21.061 94.9902 22.4879 94.9902Z",
    fill: "white",
    stroke: "#131314"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1512 94.9316C72.578 94.9318 73.737 96.0924 73.7372 97.5273C73.7372 98.9624 72.5781 100.124 71.1512 100.124C69.7242 100.124 68.5643 98.9625 68.5643 97.5273C68.5645 96.0923 69.7243 94.9316 71.1512 94.9316Z",
    fill: "white",
    stroke: "#131314"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1512 76.1074C72.578 76.1076 73.737 77.2682 73.7372 78.7031C73.7372 80.1382 72.5781 81.2996 71.1512 81.2998C69.7242 81.2998 68.5643 80.1383 68.5643 78.7031C68.5645 77.2681 69.7243 76.1074 71.1512 76.1074Z",
    fill: "white",
    stroke: "#131314"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1512 38.5996C72.578 38.5998 73.737 39.7604 73.7372 41.1953C73.7372 42.6304 72.5781 43.7918 71.1512 43.792C69.7242 43.792 68.5643 42.6305 68.5643 41.1953C68.5645 39.7603 69.7243 38.5996 71.1512 38.5996Z",
    fill: "white",
    stroke: "#131314"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1512 58.9844C72.578 58.9846 73.737 60.1452 73.7372 61.5801C73.7372 63.0152 72.5781 64.1766 71.1512 64.1768C69.7242 64.1768 68.5643 63.0153 68.5643 61.5801C68.5645 60.145 69.7243 58.9844 71.1512 58.9844Z",
    fill: "white",
    stroke: "#131314"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7935 38.5996C55.2202 38.5998 56.3792 39.7604 56.3794 41.1953C56.3794 42.6304 55.2204 43.7918 53.7935 43.792C52.3664 43.792 51.2065 42.6305 51.2065 41.1953C51.2067 39.7603 52.3665 38.5996 53.7935 38.5996Z",
    fill: "white",
    stroke: "#131314"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1123 38.5996C35.5391 38.5998 36.6981 39.7604 36.6982 41.1953C36.6982 42.6304 35.5392 43.7918 34.1123 43.792C32.6852 43.792 31.5254 42.6305 31.5254 41.1953C31.5256 39.7603 32.6854 38.5996 34.1123 38.5996Z",
    fill: "white",
    stroke: "#131314"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3458 58.502C41.7726 58.5022 42.9316 59.6627 42.9318 61.0977C42.9318 62.5327 41.7727 63.6941 40.3458 63.6943C38.9188 63.6943 37.7589 62.5329 37.7589 61.0977C37.7591 59.6626 38.9189 58.502 40.3458 58.502Z",
    fill: "white",
    stroke: "#131314"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4879 38.5996C23.9147 38.5998 25.0737 39.7604 25.0739 41.1953C25.0739 42.6304 23.9148 43.7918 22.4879 43.792C21.0609 43.792 19.901 42.6305 19.901 41.1953C19.9012 39.7603 21.061 38.5996 22.4879 38.5996Z",
    fill: "white",
    stroke: "#131314"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4879 58.502C23.9147 58.5022 25.0737 59.6627 25.0739 61.0977C25.0739 62.5327 23.9148 63.6941 22.4879 63.6943C21.0609 63.6943 19.901 62.5329 19.901 61.0977C19.9012 59.6626 21.061 58.502 22.4879 58.502Z",
    fill: "white",
    stroke: "#131314"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4879 82.8281C23.9147 82.8283 25.0737 83.9889 25.0739 85.4238C25.0739 86.8589 23.9148 88.0203 22.4879 88.0205C21.0609 88.0205 19.901 86.859 19.901 85.4238C19.9012 83.9888 21.061 82.8281 22.4879 82.8281Z",
    fill: "white",
    stroke: "#131314"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5891 58.502C53.0159 58.5022 54.1749 59.6627 54.175 61.0977C54.175 62.5327 53.016 63.6941 51.5891 63.6943C50.162 63.6943 49.0022 62.5329 49.0022 61.0977C49.0024 59.6626 50.1622 58.502 51.5891 58.502Z",
    fill: "white",
    stroke: "#131314"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.66242,
    x2: 24.4123,
    y2: -0.66242,
    transform: "matrix(-0.83251 -0.55401 0.551652 -0.834074 71.9126 98.2852)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.66242,
    x2: 26.2706,
    y2: -0.66242,
    transform: "matrix(-0.773622 -0.633648 0.631317 -0.775525 71.9126 77.3027)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.66242,
    x2: 26.8689,
    y2: -0.66242,
    transform: "matrix(-0.639276 -0.768977 0.767042 -0.641597 71.1915 61.8555)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.662421,
    x2: 30.8315,
    y2: -0.662421,
    transform: "matrix(-0.657866 0.753135 -0.751128 -0.660156 71.2102 61.0977)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.66242,
    x2: 36.675,
    y2: -0.66242,
    transform: "matrix(-0.847604 0.530629 -0.528288 -0.849065 70.9912 41.1953)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.66242,
    x2: 23.0796,
    y2: -0.66242,
    transform: "matrix(-0.506282 0.862368 -0.861005 -0.508596 33.7318 41.1953)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.66242,
    x2: 22.3409,
    y2: -0.66242,
    transform: "matrix(-0.838808 0.544428 -0.542075 -0.84033 21.8263 85.4238)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -0.662421,
    x2: 29.0448,
    y2: -0.662421,
    transform: "matrix(-0.691427 0.722446 -0.720321 -0.693641 22.4875 60.6543)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -0.66242,
    x2: 39.941,
    y2: -0.66242,
    transform: "matrix(-0.503303 0.86411 -0.86276 -0.505613 22.2676 18.418)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: -0.66242,
    x2: 24.4,
    y2: -0.66242,
    transform: "matrix(-0.805798 0.592191 -0.589828 -0.807529 21.8263 17.9746)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    y1: -0.662421,
    x2: 28.1081,
    y2: -0.662421,
    transform: "matrix(-0.704486 -0.709717 0.70755 -0.706663 22.928 85.4238)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    y1: -0.66242,
    x2: 22.5944,
    y2: -0.66242,
    transform: "matrix(-0.848913 0.528532 -0.526194 -0.850365 21.8263 41.1953)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    y1: -0.66242,
    x2: 25.0772,
    y2: -0.66242,
    transform: "matrix(-0.780839 -0.624733 0.622392 -0.782706 22.7075 18.418)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    y1: -0.66242,
    x2: 20.626,
    y2: -0.66242,
    transform: "matrix(0.331353 0.943507 -0.942867 0.333168 33.29 41.1953)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    y1: -0.662419,
    x2: 19.5406,
    y2: -0.662419,
    transform: "matrix(-0.0902604 0.995918 -0.995868 -0.090812 53.1313 41.1953)",
    stroke: "white",
    strokeWidth: 1.32484
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0644 100.184C81.9669 100.184 81.0771 99.2948 81.0771 98.1972V93.4214V85.9206V66.0693C81.0771 64.9718 81.9669 64.0821 83.0644 64.0821H121.904C123.001 64.0821 123.891 63.1923 123.891 62.0948V60.167C123.891 59.0695 123.001 58.1798 121.904 58.1798H83.0644C81.9669 58.1798 81.0771 57.29 81.0771 56.1925V45.1162C81.0771 44.0186 81.9669 43.1289 83.0644 43.1289H124.679H131.973H136.963C138.06 43.1289 138.95 44.0186 138.95 45.1162V57.3928V98.1972C138.95 99.2948 138.06 100.184 136.963 100.184H95.3485H83.0644ZM98.2949 77.247C97.0754 77.247 96.0868 78.2355 96.0868 79.455V82.999C96.0868 84.2185 97.0754 85.2071 98.2949 85.2071H121.766C122.985 85.2071 123.974 84.2185 123.974 82.999V79.455C123.974 78.2355 122.985 77.247 121.766 77.247H98.2949Z",
    fill: "#131314"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6042_1270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.247 46.0718L175.435 99.1528C175.785 99.7879 176.452 100.183 177.177 100.183H187.712C188.436 100.183 189.103 99.7889 189.452 99.1551L218.732 46.0741C219.463 44.7496 218.505 43.127 216.992 43.127H204.231C203.502 43.127 202.832 43.5258 202.484 44.1663L184.239 77.782C183.487 79.1678 181.498 79.1678 180.746 77.782L162.501 44.1663C162.154 43.5258 161.484 43.127 160.755 43.127H147.988C146.477 43.127 145.518 44.7473 146.247 46.0718Z",
    fill: "#131314"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.022 100.184H240.306H281.92C283.018 100.184 283.908 99.2948 283.908 98.1972V86.9536C283.908 85.8561 283.018 84.9664 281.92 84.9664H243.081C241.983 84.9664 241.094 84.0766 241.094 82.9791V81.0748C241.094 79.9773 241.983 79.0876 243.081 79.0876H281.92C283.018 79.0876 283.908 78.1979 283.908 77.1003V57.336V45.1162C283.908 44.0186 283.018 43.1289 281.92 43.1289L276.78 43.1289H269.636H240.306H228.022C226.925 43.1289 226.035 44.0186 226.035 45.1162V50.3828V57.336V85.7502V93.6145V98.1972C226.035 99.2948 226.925 100.184 228.022 100.184ZM243.08 65.9728H266.86C267.958 65.9728 268.848 65.0831 268.848 63.9855V60.1168C268.848 59.0193 267.958 58.1295 266.86 58.1295H243.08C241.982 58.1295 241.092 59.0193 241.092 60.1168V63.9855C241.092 65.0831 241.982 65.9728 243.08 65.9728Z",
    fill: "#131314"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M292.895 100.184H308.226H332.573C333.67 100.184 334.56 99.2946 334.56 98.197V84.0152C334.56 82.9177 333.67 82.028 332.573 82.028H311.044C309.946 82.028 309.056 81.1383 309.056 80.0407V54.0617C309.056 52.9642 309.946 52.0744 311.044 52.0744H332.573C333.67 52.0744 334.56 51.1847 334.56 50.0872V35.9054C334.56 34.8078 333.67 33.9181 332.573 33.9181H311.044C309.946 33.9181 309.056 33.0284 309.056 31.9309V7.63179C309.056 6.53426 308.167 5.64453 307.069 5.64453H292.895C291.797 5.64453 290.907 6.53426 290.907 7.63179V82.9773V91.438L290.908 98.1973C290.908 99.2947 291.798 100.184 292.895 100.184Z",
    fill: "#131314"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M355.831 100.184C353.933 100.184 346.999 100.184 343.544 100.184C342.446 100.184 341.56 99.2948 341.56 98.1972V93.4915V85.9206V57.3928V50.3764V45.1162C341.56 44.0186 342.45 43.1289 343.547 43.1289H355.831H385.161H392.473H397.446C398.543 43.1289 399.433 44.0151 399.433 45.1126C399.433 48.566 399.433 55.4958 399.433 57.3928V85.9206C399.433 87.8176 399.433 94.7474 399.433 98.2008C399.433 99.2983 398.543 100.184 397.446 100.184H393.202C393.202 100.184 387.786 100.184 385.161 100.184H355.831ZM356.619 83.1463C356.619 84.2439 357.509 85.1336 358.606 85.1336H382.387C383.484 85.1336 384.374 84.2439 384.374 83.1463V60.167C384.374 59.0695 383.484 58.1798 382.387 58.1798H358.606C357.509 58.1798 356.619 59.0695 356.619 60.167V83.1463Z",
    fill: "#131314"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M415.27 100.183C412.671 100.183 410.534 99.4323 408.859 97.9305C407.241 96.371 406.433 94.465 406.433 92.2124C406.433 89.902 407.241 87.9671 408.859 86.4076C410.534 84.8481 412.671 84.0684 415.27 84.0684C417.811 84.0684 419.891 84.8481 421.508 86.4076C423.183 87.9671 424.02 89.902 424.02 92.2124C424.02 94.465 423.183 96.371 421.508 97.9305C419.891 99.4323 417.811 100.183 415.27 100.183Z",
    fill: "#131314"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M431.02 98.1836V45.1836C431.02 44.079 431.916 43.1836 433.02 43.1836H481.02C482.125 43.1836 483.02 44.079 483.02 45.1836V56.3178C483.02 57.4224 482.125 58.3178 481.02 58.3178H448.02C446.916 58.3178 446.02 59.2133 446.02 60.3178V83.1836C446.02 84.2882 446.916 85.1836 448.02 85.1836H481.02C482.125 85.1836 483.02 86.079 483.02 87.1836V98.1836C483.02 99.2882 482.125 100.184 481.02 100.184H433.02C431.916 100.184 431.02 99.2882 431.02 98.1836Z",
    fill: "#131314"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M504.323 100.184C502.42 100.184 495.465 100.184 492.004 100.184C490.907 100.184 490.02 99.2939 490.02 98.1963V93.4971V85.9336V57.4336V50.424V45.1709C490.02 44.0733 490.91 43.1836 492.008 43.1836H504.323H533.718H541.045H546.033C547.131 43.1836 548.02 44.0697 548.02 45.1673C548.02 48.6179 548.02 55.5388 548.02 57.4336V85.9336C548.02 87.8284 548.02 94.7493 548.02 98.1999C548.02 99.2975 547.131 100.184 546.033 100.184H541.776C541.776 100.184 536.348 100.184 533.718 100.184H504.323ZM505.112 83.1601C505.112 84.2576 506.002 85.1474 507.099 85.1474H530.941C532.039 85.1474 532.929 84.2576 532.929 83.1601V60.2071C532.929 59.1095 532.039 58.2198 530.941 58.2198H507.099C506.002 58.2198 505.112 59.1095 505.112 60.207V83.1601Z",
    fill: "#131314"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M572.487 58.1836C571.382 58.1836 570.487 59.079 570.487 60.1836V98.1836C570.487 99.2882 569.591 100.184 568.487 100.184H557.02C555.916 100.184 555.02 99.2882 555.02 98.1836V45.1836C555.02 44.079 555.916 43.1836 557.02 43.1836H628.02C629.125 43.1836 630.02 44.079 630.02 45.1836V73.3197V98.1836C630.02 99.2882 629.125 100.184 628.02 100.184H618.02C616.916 100.184 616.02 99.2882 616.02 98.1836V60.1836C616.02 59.079 615.125 58.1836 614.02 58.1836H602.52C601.416 58.1836 600.52 59.079 600.52 60.1836V97.6836C600.52 98.7882 599.625 99.6836 598.52 99.6836H588.02C586.916 99.6836 586.02 98.7882 586.02 97.6836V60.1836C586.02 59.079 585.125 58.1836 584.02 58.1836H572.487Z",
    fill: "#131314"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6042_1270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.085,
    height: 57.0556,
    fill: "white",
    transform: "translate(145.95 43.1289)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaveto);
export default __webpack_public_path__ + "static/media/haveto.baf7cf6d268ce324ff24cc67afa29c6f.svg";
export { ForwardRef as ReactComponent };